// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t_EO","content":"styles_content__GzOAB"};